import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MultiCartService, StateWithMultiCart } from '@spartacus/cart/base/core';
import { Cart, OrderEntry } from '@spartacus/cart/base/root';
import { WishListService } from '@spartacus/cart/wish-list/core';
import {
  OCC_USER_ID_ANONYMOUS,
  UserIdService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { combineLatest, Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UigWishListService extends WishListService {
  constructor(
    protected store: Store<StateWithMultiCart>,
    protected userService: UserAccountFacade,
    protected multiCartService: MultiCartService,
    protected userIdService: UserIdService,

    protected userAccountFacade: UserAccountFacade
  ) {
    super(store, userService, multiCartService, userIdService);
  }

  public wishlistLoaded: boolean = false;

  private lastEntryListedStatus: boolean = false;

   getWishList(): Observable<Cart> {
    return combineLatest([
      this.getWishListId(),
      this.userAccountFacade.get(),
      this.userIdService.getUserId(),
    ]).pipe(
      distinctUntilChanged(),
      tap(([wishListId, user, userId]) => {
        if (
          !Boolean(wishListId) &&
          userId !== OCC_USER_ID_ANONYMOUS &&
          Boolean(user) &&
          Boolean(user.uid)
        ) {
          if (!this.wishlistLoaded) {
            this.loadWishList(userId, user.uid);
            this.wishlistLoaded = true;
          }
        }
      }),
      filter(([wishListId]) => Boolean(wishListId)),
      switchMap(([wishListId]) => this.multiCartService.getCart(wishListId))
    );
  }

  addEntry(productCode: string): void {
    this.getWishListId()
      .pipe(
        distinctUntilChanged(),
        withLatestFrom(this.userIdService.getUserId(), this.userAccountFacade.get()),
        tap(([wishListId, userId, user]) => {
          if (!Boolean(wishListId) && Boolean(user) && Boolean(user.uid)) {
            this.loadWishList(userId, user.uid);
          }
        }),
        filter(([wishListId]) => Boolean(wishListId)),
        take(1)
      )
      .subscribe(([wishListId, userId]) =>
        this.multiCartService.addEntry(userId, wishListId, productCode, 1)
      );
   }

  removeEntry(entry: OrderEntry): void {
    this.getWishListId()
      .pipe(
        distinctUntilChanged(),
        withLatestFrom(this.userIdService.getUserId(), this.userAccountFacade.get()),
        tap(([wishListId, userId, user]) => {
          if (!Boolean(wishListId) && Boolean(user) && Boolean(user.uid)) {
            this.loadWishList(userId, user.uid);
          }
        }),
        filter(([wishListId]) => Boolean(wishListId)),
        take(1)
      )
      .subscribe(([wishListId, userId]) =>
        this.multiCartService.removeEntry(userId, wishListId, entry.entryNumber)
      );
  }
  getLastEntryListedStatus(): boolean {
    return this.lastEntryListedStatus;
  }

  setLastEntryListedStatus(lastEntryListedStatus: boolean): void {
    this.lastEntryListedStatus = lastEntryListedStatus;
  }

}
